export const isWeekend = (dateString: string): boolean => {
  try {
    const day = new Date(dateString).getDay();
    return [0, 6].includes(day);
  } catch (_) {
    return false;
  }
};
